import {BillingPlanPanel} from '../billing-page/billing-plan-panel';
import {Trans} from '@ui/i18n/trans';
import {Button} from '@ui/buttons/button';
import {CancelIcon} from '@ui/icons/material/Cancel';
import {useNavigate} from '@common/ui/navigation/use-navigate';

export function PaymentCancelledPage() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-0 md:p-24 max-w-1280">
      <BillingPlanPanel title={<Trans message="Payment Cancelled" />}>
        <div className="text-center py-32">
          {/* Cancelled Icon */}
          <div className="flex justify-center mb-16">
            <div className="w-64 h-64 bg-danger/10 rounded-full flex items-center justify-center">
              <CancelIcon size="lg" className="text-danger" />
            </div>
          </div>

          {/* Cancelled Message */}
          <h2 className="text-2xl font-bold text-danger mb-8">
            <Trans message="Payment Was Cancelled" />
          </h2>

          <p className="text-muted mb-24 max-w-md mx-auto">
            <Trans message="Your payment was cancelled and no charges were made. You can try again whenever you're ready." />
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-12 justify-center">
            <Button
              variant="flat"
              color="primary"
              onClick={() => navigate('/shop')}
            >
              <Trans message="Return to Shop" />
            </Button>

            <Button
              variant="outline"
              onClick={() => navigate('/')}
            >
              <Trans message="Go to Homepage" />
            </Button>
          </div>
        </div>
      </BillingPlanPanel>
    </div>
  );
}